import { toCanvas } from "html-to-image";
import { LUCK_PRINT_WIDTH_PX } from "@/modules/chat-tools/domain/luck-printer/protocol";
import { normalizeLabelWidth } from "./bitmap-to-luck-raster";

async function waitForImages(root: HTMLElement) {
  const images = Array.from(root.querySelectorAll("img"));
  await Promise.all(
    images.map(
      (img) =>
        new Promise<void>((resolve) => {
          if (img.complete) {
            resolve();
            return;
          }
          img.onload = () => resolve();
          img.onerror = () => resolve();
        }),
    ),
  );
}

export async function renderLabelBitmap(
  element: HTMLElement,
  targetWidth = LUCK_PRINT_WIDTH_PX,
): Promise<ImageData> {
  await waitForImages(element);

  const canvas = await toCanvas(element, {
    cacheBust: true,
    pixelRatio: 2,
    backgroundColor: "#ffffff",
  });

  const scale = targetWidth / canvas.width;
  const targetHeight = Math.max(1, Math.ceil(canvas.height * scale));
  const scaled = document.createElement("canvas");
  scaled.width = targetWidth;
  scaled.height = targetHeight;
  const ctx = scaled.getContext("2d");
  if (!ctx) throw new Error("Canvas not supported");

  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, targetWidth, targetHeight);
  ctx.imageSmoothingEnabled = false;
  ctx.drawImage(canvas, 0, 0, targetWidth, targetHeight);

  return normalizeLabelWidth(
    ctx.getImageData(0, 0, targetWidth, targetHeight),
  );
}

export async function renderLabelPreviewDataUrl(
  element: HTMLElement,
): Promise<string> {
  const imageData = await renderLabelBitmap(element);
  const canvas = document.createElement("canvas");
  canvas.width = imageData.width;
  canvas.height = imageData.height;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Canvas not supported");
  ctx.putImageData(imageData, 0, 0);
  return canvas.toDataURL("image/png");
}
